import { cloudFunctions } from "./firebase";

export const initUser = (email, firstName, phone, hasReadToS, isProvider) => {
  return cloudFunctions
    .httpsCallable("httpsInitUser")
    .call(this, {
      email,
      firstName,
      phone,
      hasReadToS,
      isProvider
    })
    .then(json => {
      const { result } = json.data;
      return result;
    });
};

export const stripeConnectStartOnboard = () => {
  return cloudFunctions
    .httpsCallable("httpsStripeConnectStartOnboard")
    .call()
    .then(json => {
      const { result } = json.data;
      if (result) {
        return result;
      } else {
        return false;
      }
    })
    .catch(error => {
      // console.log("DOUGIE ERROR");
      console.log(error.message);
      return false;
    });
};

export const stripeConnectFinishOnboard = (code, state) => {
  return cloudFunctions
    .httpsCallable("httpsStripeConnectFinishOnboard")
    .call(this, {
      code,
      state
    })
    .then(json => {
      const { result } = json.data;
      return result;
    });
};

export const assignOpenJobs = () => {
  return cloudFunctions
    .httpsCallable("httpsOfferScheduledVehicleJobs")
    .call()
    .then(json => {
      const { result } = json.data;
      alert(result);
      return result;
    })
    .catch(error => {
      alert(error.message);
      return null;
    });
};



// WEBPACK FOOTER //
// ./src/firebase/cloudFunctions.js